"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Container_1 = require("../Container/Container");
const services_1 = require("../Definition/services");
const App_1 = require("../App/App");
const PluginCompilerPass_1 = require("../Plugin/PluginCompilerPass");
const ExtendableCompilerPass_1 = require("../Extendable/ExtendableCompilerPass");
const extendables_1 = require("../Definition/extendables");
const WidgetError_1 = require("../Error/WidgetError");
const plugins_1 = require("../Definition/plugins");
/**
 * Builder for application.
 *
 * Used to define container services, plugins and other
 * extensions on application specifications.
 */
class AppBuilder {
    constructor() {
        /**
         * The container.
         *
         * @type {Container}
         */
        this.container = new Container_1.Container(services_1.services);
        /**
         * Extended classes.
         *
         * @type {*}
         */
        this.extensions = {};
        /**
         * List of plugins.
         *
         * @type {PluginDefinition[]}
         */
        this.plugins = Array.from(plugins_1.plugins);
        /**
         * Bundles registered.
         *
         * @type IBundle
         */
        this.bundles = [];
    }
    /**
     * Adds container compiler pass.
     *
     * @param {ICompilerPass} compilerPass
     * @return {this}
     */
    addCompilerPass(compilerPass) {
        this.container.addCompilerPass(compilerPass);
        return this;
    }
    /**
     * Adds container parameter.
     *
     * @param {string} key
     * @param value
     * @return {this}
     */
    addParameter(key, value) {
        this.container.setParameter(key, value);
        return this;
    }
    /**
     * Adds container services.
     *
     * @param services
     * @return {this}
     */
    addServices(services) {
        for (let [id, definition] of Object.entries(services)) {
            this.addService(id, definition);
        }
        return this;
    }
    /**
     * Adds container service.
     *
     * @param {string} id
     * @param definition
     * @return {this}
     */
    addService(id, definition) {
        this.container.addDefinition(id, definition);
        return this;
    }
    /**
     * Adds plugin.
     *
     * @param {PluginDefinition} definition
     */
    addPlugin(definition) {
        this.plugins.push(definition);
        return this;
    }
    /**
     * Adds plugins.
     *
     * @param {PluginDefinition[]} definitions
     */
    addPlugins(definitions) {
        this.plugins = this.plugins.concat(definitions);
        return this;
    }
    /**
     * Sets extendable.
     *
     * @return {App}
     */
    setExtended(extendableId, classReference) {
        if (!extendables_1.extendables[extendableId]) {
            throw new WidgetError_1.default(`Undefined extendable.`);
        }
        this.extensions[extendableId] = classReference;
        return this;
    }
    /**
     * Adds a bundle to the application.
     *
     * @param bundle
     */
    addBundle(bundle) {
        if (this.bundles.indexOf(bundle) !== -1) {
            throw new WidgetError_1.default(`Duplicate bundle registration ${bundle.constructor.name}`);
        }
        this.bundles.push(bundle);
        bundle.register(this);
        return this;
    }
    /**
     * Creates the application.
     *
     * @return {IApp}
     */
    create() {
        this.container.addCompilerPass(new PluginCompilerPass_1.default(this.plugins));
        this.container.addCompilerPass(new ExtendableCompilerPass_1.default(extendables_1.extendables, this.extensions));
        return App_1.default(this.container);
    }
}
exports.default = AppBuilder;
